module.exports = __webpack_public_path__ + "img/finance.9f751c78.png";